/**
 * @internal
 *
 * Whether the code is currently executed in a browser
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/main/packages/utils/src/dom.ts}
 */
export const isBrowser = (() => {
  return !!(
    typeof window !== 'undefined' &&
    window.document &&
    /* oxlint-disable-next-line typescript/no-deprecated --
    one overload of createElement is deprecated, apparently our plugin does not get that */
    window.document.createElement
  );
})();
